import angular from 'angular';
import registrationErrorCodesModule from 'registration/config/errorcodes.conf';
import registrationSelfModule from 'registration/components/self-registration/self-registration-module';
import registrationCompleteModule from 'registration/components/complete-registration/complete-registration-module';
import registrationRoutingModule from 'registration/registration-routing-module';
import securityModule from 'security/security-module';

export default angular.module('registration', [
  securityModule.name,
  registrationErrorCodesModule.name,
  registrationSelfModule.name,
  registrationCompleteModule.name,
  registrationRoutingModule.name,
]);



// WEBPACK FOOTER //
// ./src/modules/registration/registration-module.js